<p-toast position="top-right" styleClass="ip-auth-toast"></p-toast>

<div class="up-page">
  <div class="up-card">
    <div class="up-icon">
      <i class="pi pi-lock"></i>
    </div>

    <h2 class="up-title">Forgot Password?</h2>
    <p class="up-sub">
      Enter your email and we’ll help you<br />
      reset your password
    </p>

    <div class="up-form">
      <label>New Password <span class="up-required">*</span></label>
      <div class="up-input-wrap">
        <input
          [type]="showNewPassword ? 'text' : 'password'"
          [(ngModel)]="newPassword"
          class="up-input"
          placeholder="Min. 8 characters"
        />
        <button
          type="button"
          class="up-eye"
          (click)="showNewPassword = !showNewPassword"
          tabindex="-1"
        >
          <i [class]="showNewPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
        </button>
      </div>

      <label>Confirm Password <span class="up-required">*</span></label>
      <div class="up-input-wrap">
        <input
          [type]="showConfirmPassword ? 'text' : 'password'"
          [(ngModel)]="confirmPassword"
          class="up-input"
          placeholder="Re-enter password"
        />
        <button
          type="button"
          class="up-eye"
          (click)="showConfirmPassword = !showConfirmPassword"
          tabindex="-1"
        >
          <i [class]="showConfirmPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
        </button>
      </div>

      @if (errorMessage) {
        <p style="color: #dc2626; font-size: 0.85rem; margin: 0.25rem 0 0.5rem">
          {{ errorMessage }}
        </p>
      }

      <button
        class="up-btn"
        (click)="updatePassword()"
        [disabled]="loading || !newPassword || !confirmPassword"
      >
        {{ loading ? 'Updating…' : 'Update Password' }}
      </button>
    </div>
  </div>
</div>
